const normalizeBaseUrl = (value = "") =>
  String(value || "")
    .trim()
    .replace(/\/+$/, "");

const STATUS_API_BASE_URL =
  normalizeBaseUrl(
    process.env.REACT_APP_STATUS_API_BASE_URL ||
      process.env.REACT_APP_API_BASE_URL ||
      process.env.REACT_APP_API_SERVER
  ) || "https://server-9p4hx.kinsta.app";

export const buildStatusApiUrl = (path) => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${STATUS_API_BASE_URL}${normalizedPath}`;
};

export default STATUS_API_BASE_URL;
